import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { Menu } from '@headlessui/react';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import { isAndroidDevice } from '~/components/PWA/isAndroidDevice';
import { isIosDevice } from '~/components/PWA/isIosDevice';
import { showInstallPrompt } from '~/components/PWA/utils';
import Typography from '~/components/Typography';
import { useDisplayMode } from '~/hooks/useDisplayMode';
import useIsLoggedIn from '~/hooks/useIsLoggedIn';

import InstallMobileIcon from './InstallMobileIcon';

const InstallApp = () => {
  const { webTheme: theme } = useWebThemeContext();
  const isAndroid = isAndroidDevice();
  const isIos = isIosDevice();
  const isMobile = isAndroid || isIos;
  const isLoggedIn = useIsLoggedIn();
  const displayMode = useDisplayMode();
  const { t } = useTranslation();

  const Icon = InstallMobileIcon;
  const label = t('nav.install.label');

  // only show install button if mobile, and not already installed
  const showInstall = isMobile && displayMode !== 'standalone';
  if (!showInstall) return null;

  return (
    <Menu.Item>
      <div
        className="flex items-center px-6 py-3 space-x-2 cursor-pointer"
        onClick={() => {
          if (!isLoggedIn) {
            toast.error(t('nav.install.not_logged_in'));
            return;
          }
          showInstallPrompt();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            showInstallPrompt();
          }
        }}
      >
        <div
          style={{
            color: isLoggedIn ? theme?.navbar_text_color : '#a1a1aa',
          }}
        >
          <Icon className="w-4 h-4" />
        </div>
        <Typography
          as="span"
          className=""
          color={isLoggedIn ? theme?.navbar_text_color : '#a1a1aa'}
          weight="medium"
          fontFamilyv2={theme.navbar_font_family}
          size="sm"
        >
          {label}
        </Typography>
      </div>
    </Menu.Item>
  );
};

export default InstallApp;
